'use strict'
import Helper from '@/utils/helper'
import AppInfoHelper from '@/utils/app-info-helper'

const responseInterceptor = () => response => {
  if (process.env.VUE_APP_CONSOLE === 'ON') {
    console.log(response.data, response.headers)
  }
  response.axios = true

  if (Helper.isDefined(response.headers['x-softlogic-version'])) {
    AppInfoHelper.updateVersion(response.headers['x-softlogic-version'])
  }
  if (Helper.isDefined(response.headers['x-softlogic-header'])) {
    return response
  } else {
    return false
  }
}

export default responseInterceptor
